
import { TikTokVideo } from "@/types/api";
import { ProgressState, DownloadStatus } from "@/hooks/useBulkDownload";

export function getDownloadableVideos(videos: TikTokVideo[], selected: string[]) {
  if (selected.length === 0) {
    return videos.filter((v) => v.status !== "unavailable");
  }
  return videos.filter((v) => v.status !== "unavailable" && selected.includes(v.id));
}

export function createDownloadOrderMap(downloadList: TikTokVideo[]) {
  return Object.fromEntries(downloadList.map((v, idx) => [v.id, idx + 1]));
}

export function isVideoCompleted(id: string, progressState: ProgressState) {
  return progressState[id]?.status === "complete" || 
         progressState[id]?.status === "failed";
}

export function calculateProgressCounts(downloadList: TikTokVideo[], progressState: ProgressState) {
  const counts = { 
    total: downloadList.length, 
    in_progress: 0, 
    complete: 0, 
    failed: 0, 
    paused: 0, 
    pending: 0 
  };

  for (let v of downloadList) {
    const ps = progressState[v.id];
    if (!ps) { 
      counts.pending++; 
      continue; 
    }
    if (ps.status === "in_progress") counts.in_progress++;
    if (ps.status === "complete") counts.complete++;
    if (ps.status === "failed" && v.status !== "unavailable") counts.failed++;
    if (ps.status === "paused") counts.paused++;
    if (ps.status === "not_started") counts.pending++;
  }
  return counts;
}
